import React, { useEffect } from "react";
import {
  DatePicker,
  LocalizationProvider,
  MobileTimePicker,
} from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import TextField from "./FormElements/TextField";

const DateAndTime = ({
  startDate,
  setStartDate,
  setStartTime,
  startTime,
  dateLable = "Select Date",
  timeLable = "Select Time",
}) => {

  useEffect(() => {
    const now = new Date();
    // Initialize current local date and time with timezone
    setStartDate(now);
    setStartTime(now);
  }, [setStartDate, setStartTime]);

  const handleDateChange = (newValue) => {
    if (newValue) {
      const localDate = new Date(
        newValue.getFullYear(),
        newValue.getMonth(),
        newValue.getDate()
      );
      setStartDate(localDate);
    }
  };

  const handleTimeChange = (newValue) => {
    if (newValue) {
      const localTime = new Date(newValue);
      setStartTime(localTime);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        label={dateLable}
        value={startDate}
        onChange={handleDateChange}
        slotProps={{ textField: { size: "small" } }}
        format="dd/MM/yyyy"
        renderInput={(params) => (
          <TextField {...params} className="w-full h-[10px]" />
        )}
      />

      <MobileTimePicker
        label={timeLable}
        slotProps={{ textField: { size: "small" } }}
        value={startTime}
        onChange={handleTimeChange}
        renderInput={(params) => (
          <TextField {...params} label={timeLable} className="w-full" />
        )}
      />
    </LocalizationProvider>
  );
};

export default DateAndTime;
